import "./Page.css";
import React, { useState, useEffect } from 'react';
import { getRuPageSlug } from '../../index';
import RouteUrl from '../RouteEnum';
import axios from 'axios'
import Footer from '../PageComponents/Footer';
import Header from '../PageComponents/Header';
import BlogList from '../Blog/BlogList';
import ErrorWrapper from "../PageComponents/ErrorWrapper";


const BlogPage = () => {
    const [data, setData] = useState({});
    const [error, setError] = useState(false);
    const path = [{ link: "", title: "Блог" }];

    useEffect(() => {
        window.scrollTo(0, 0);
        axios.get(getRuPageSlug(RouteUrl.blog)).then(res => {
            setData(res.data);
        }).catch(err => setError(true));
    }, []);

    return (
        <ErrorWrapper error={error}>
            <Header path={path} data={data} />
            <div className="frame last">
                <h1 className="main-header">Блог</h1>
                <BlogList />
            </div>
            <Footer nested="1" />
        </ErrorWrapper>
    );
}

export default BlogPage;